export {
  ClassPageWrapper as default,
  getServerSideProps
} from "~/wrappers/ClassPageWrapper";
